'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _idGen = require('../../utils/idGen');

var _idGen2 = _interopRequireDefault(_idGen);

var _classConcat = require('../../utils/classConcat');

var _classConcat2 = _interopRequireDefault(_classConcat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var Button = function Button(_a) {
    var ariaExpanded = _a.ariaExpanded,
        ariaControls = _a.ariaControls,
        link = _a.link,
        _a$href = _a.href,
        href = _a$href === undefined ? link : _a$href,
        onClick = _a.onClick,
        _a$id = _a.id,
        id = _a$id === undefined ? (0, _idGen2.default)('button') : _a$id,
        modifiers = _a.modifiers,
        classNames = _a.classNames,
        _a$className = _a.className,
        className = _a$className === undefined ? classNames : _a$className,
        label = _a.label,
        ariaLabel = _a.ariaLabel,
        disabled = _a.disabled,
        iconColor = _a.iconColor,
        iconName = _a.iconName,
        iconSize = _a.iconSize,
        iconTitle = _a.iconTitle,
        iconClassName = _a.iconClassName,
        iconSpanDescription = _a.iconSpanDescription,
        iconRight = _a.iconRight,
        type = _a.type,
        children = _a.children,
        newTab = _a.newTab,
        noFollow = _a.noFollow,
        rest = __rest(_a, ["ariaExpanded", "ariaControls", "link", "href", "onClick", "id", "modifiers", "classNames", "className", "label", "ariaLabel", "disabled", "iconColor", "iconName", "iconSize", "iconTitle", "iconClassName", "iconSpanDescription", "iconRight", "type", "children", "newTab", "noFollow"]);

    var iconOnly = !label && !children;
    var target = void 0;
    if (newTab) {
        target = '_blank';
    }
    var baseClass = 'luna-button';
    var buttonClasses = (0, _classnames2.default)([baseClass, (0, _classConcat2.default)(baseClass, modifiers), { iconOnly: iconOnly }, className]);
    var icon = iconName && _react2.default.createElement(_Icon2.default, { name: iconName, size: iconSize, title: iconTitle, className: iconClassName, ariaHidden: iconOnly.toString(), spanDescription: iconSpanDescription, color: iconColor });
    var buttonProps = Object.assign({ href: href,
        id: id,
        target: target, className: buttonClasses, 'aria-label': ariaLabel, 'aria-expanded': ariaExpanded, 'aria-controls': ariaControls }, rest);
    if (noFollow) {
        buttonProps.rel = 'nofollow';
    }
    return href ? _react2.default.createElement("a", Object.assign({}, buttonProps, { role: "button", onClick: onClick, onKeyDown: onClick }), !iconRight && icon, _react2.default.createElement("span", null, label), children, iconRight && icon) : _react2.default.createElement("button", Object.assign({}, buttonProps, { type: type, disabled: disabled, onClick: onClick }), !iconRight && icon, _react2.default.createElement("span", null, label), children, iconRight && icon);
};
Button.propTypes = {
    label: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
    ariaLabel: _propTypes2.default.string,
    id: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    modifiers: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
    onClick: _propTypes2.default.func,
    iconColor: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    iconSize: _propTypes2.default.string,
    iconTitle: _propTypes2.default.string,
    iconRight: _propTypes2.default.bool,
    type: _propTypes2.default.oneOf(['button', 'reset', 'submit']),
    link: _propTypes2.default.string,
    href: _propTypes2.default.string,
    noFollow: _propTypes2.default.bool,
    ariaExpanded: _propTypes2.default.bool,
    ariaControls: _propTypes2.default.string,
    classNames: _propTypes2.default.string,
    iconClassName: _propTypes2.default.string,
    iconSpanDescription: _propTypes2.default.string,
    children: _propTypes2.default.node,
    newTab: _propTypes2.default.bool
};
Button.defaultProps = {
    className: '',
    ariaLabel: '',
    disabled: false,
    modifiers: '',
    type: 'button',
    link: null,
    noFollow: false,
    classNames: '',
    newTab: false,
    iconColor: '',
    iconName: '',
    iconSize: '',
    iconTitle: '',
    iconRight: false,
    iconClassName: '',
    iconSpanDescription: ''
};
exports.default = Button;
//# sourceMappingURL=Button.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Button/Button.js